import { BALANCE } from './balance-config';

class AudioService {
    phaser = undefined;

    audioFiles = [
        // Sound
        {
            name: 'fight-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Attack.mp3',
            cooldown: 3000
        },
        {
            name: 'build-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_BuildingWalls_01.mp3',
            cooldown: 3000
        },
        {
            name: 'build-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_BuildingWalls_02.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_01.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_02.mp3',
            cooldown: 3000
        },
        {
            name: 'carpenter-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_03.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_04.mp3',
            cooldown: 3000
        },
        {
            name: 'carpenter-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_05.mp3',
            cooldown: 3000
        },
        {
            name: 'carpenter-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_06.mp3',
            cooldown: 3000
        },
        {
            name: 'carpenter-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_07.mp3',
            cooldown: 3000
        },
        {
            name: 'carpenter-5',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_08.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-9',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_09.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-10',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_10.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-11',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_11.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-12',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_12.mp3',
            cooldown: 3000
        },
        {
            name: 'lock',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_13.mp3',
            cooldown: 3000
        },
        {
            name: 'kitchen',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_14.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-15',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_15.mp3',
            cooldown: 3000
        },
        {
            name: 'collectWood-16',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_16.mp3',
            cooldown: 3000
        },
        {
            name: 'blacksmith',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ChoppingPlants_16.mp3',
            cooldown: 3000
        },
        {
            name: 'closeMenu',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CloseMenu.mp3',
            cooldown: 0
        },
        {
            name: 'collectItem',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_1.mp3',
            cooldown: 3000
        },
        {
            name: 'collectItem-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_1.mp3',
            cooldown: 3000
        },
        {
            name: 'collectItem-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_2.mp3',
            cooldown: 3000
        },
        {
            name: 'collectItem-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_3.mp3',
            cooldown: 3000
        },
        {
            name: 'collectItem-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_4.mp3',
            cooldown: 3000
        },
        {
            name: 'collectItem-5',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingItems_5.mp3',
            cooldown: 3000
        },
        {
            name: 'collectPlant-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_01.mp3',
            cooldown: 3000
        },
        {
            name: 'collectPlant-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_02.mp3',
            cooldown: 3000
        },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_03.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_04.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_05.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_06.mp3',
        //     cooldown: 3000
        // },
        {
            name: 'collectPlant-7',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_07.mp3',
            cooldown: 3000
        },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_08.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_09.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_10.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_11.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_12.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_13.mp3',
        //     cooldown: 3000
        // },
        // {
        //     name: '',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_CollectingPlants_14.mp3',
        //     cooldown: 3000
        // },
        {
            name: 'confirm', //unused!
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Confirm.mp3',
            cooldown: 3000
        },
        {
            name: 'hunger', //unused!
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_HungerAlert.mp3',
            cooldown: 3000
        },
        {
            name: 'generate', //unused!
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_OpeningSound.mp3',
            cooldown: 3000
        },
        {
            name: 'openMenu',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_OpenMenu.mp3',
            cooldown: 0
        },
        {
            name: 'potter',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Potter.mp3',
            cooldown: 3000
        },
        {
            name: 'fire',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_RangedAttackFireball.mp3',
            cooldown: 3000
        },
        {
            name: 'scrollMenu',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_ScrollMenu.mp3',
            cooldown: 0
        },
        // {
        //     name: 'speak-1',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_soundSpeaking_01.mp3',
        //     cooldown: 3000
        // },
        {
            name: 'speak-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_soundSpeaking_02.mp3',
            cooldown: 1000
        },
        // {
        //     name: 'speak-3',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_soundSpeaking_03.mp3',
        //     cooldown: 3000
        // },
        {
            name: 'mason-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Stones.mp3',
            cooldown: 3000
        },
        {
            name: 'collectMineral',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Stones.mp3',
            cooldown: 3000
        },
        {
            name: 'collier-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves01.mp3',
            cooldown: 3000
        },
        {
            name: 'collier-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves02.mp3',
            cooldown: 3000
        },
        {
            name: 'collier-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves03.mp3',
            cooldown: 3000
        },
        {
            name: 'step-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves04.mp3',
            cooldown: 1000
        },
        {
            name: 'step-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves05.mp3',
            cooldown: 1000
        },
        {
            name: 'step-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves06.mp3',
            cooldown: 1000,
            volume: 0.3
        },
        {
            name: 'craft-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves07.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'craft-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves08.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'craft-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves09.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'tailor-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves10.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'tailor-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves11.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'tailor-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingLeaves12.mp3',
            cooldown: 3000,
            volume: 0.3
        },
        {
            name: 'doctor-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_01.mp3',
            cooldown: 3000
        },
        {
            name: 'doctor-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_02.mp3',
            cooldown: 3000
        },
        {
            name: 'doctor-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_03.mp3',
            cooldown: 3000
        },
        {
            name: 'doctor-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_04.mp3',
            cooldown: 3000
        },
        {
            name: 'tanner-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_05.mp3',
            cooldown: 3000
        },
        {
            name: 'tanner-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_06.mp3',
            cooldown: 3000
        },
        {
            name: 'tanner-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_07.mp3',
            cooldown: 3000
        },
        {
            name: 'tanner-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_08.mp3',
            cooldown: 3000
        },
        {
            name: 'tanner-5',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_WalkingWet_09.mp3',
            cooldown: 3000
        },
        {
            name: 'write-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Writing_01.mp3',
            cooldown: 3000
        },
        {
            name: 'write-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Writing_02.mp3',
            cooldown: 3000
        },
        {
            name: 'write-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Writing_03.mp3',
            cooldown: 3000
        },
        {
            name: 'write-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Writing_04.mp3',
            cooldown: 3000
        },
        {
            name: 'write-5',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG_Writing_05.mp3',
            cooldown: 3000
        },
    ];

    musicFiles = [
        // Music
        {
            name: 'dry',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Dryspell_1.mp3',
            mood: 'moderate'
        },
        {
            name: 'evergreen',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Evergreen_1.mp3',
            mood: 'safe'
        },
        {
            name: 'mountains',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Mayaya_2(sandy,%20mountains).mp3',
            mood: 'moderate'
        },
        {
            name: 'tundra',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Octagonal_2.mp3',
            mood: 'moderate'
        },
        {
            name: 'savannah',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Sav%20Anna_1.mp3',
            mood: 'safe'
        },
        {
            name: 'forests',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Shimmer-Dimmer_2(forests,%20fur%20forests,%20mines).mp3',
            mood: 'moderate'
        },
        {
            name: 'steppes',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/Steppes.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-1',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-1.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-2.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-3',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-3.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-4',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-4.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-5',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-5.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-6',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-6.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-7',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-7.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-8',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dom-song-8.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-9',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/a%20minor%20invconvenience.mp3',
            mood: 'safe'
        },
        {
            name: 'dom-10',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/an%20idea%20about%20how%20maybe%20you%20shouldnt%20have%20left.mp3',
            mood: 'safe'
        },
        {
            name: 'dom-11',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/another%20fricking%20quagmire%20just%20my%20luck.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-12',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/doo%20doo%20doo%20doo%20doo%20doo%20doo%20doo%20doo.mp3',
            mood: 'moderate'
        },
        {
            name: 'dom-13',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/fft%20droney%20drone.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-14',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/heartE%20loop.mp3',
        },
        {
            name: 'dom-15',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/in%20which%20the%20locals%20spot%20an%20idiot%20sailor.mp3',
            mood: 'safe'
        },
        {
            name: 'dom-16',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG%20ice_1.mp3',
            mood: 'moderate'
        },
        {
            name: 'dom-17',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/sg%20lush%20synthetic%20jungle.mp3',
            mood: 'safe'
        },
        {
            name: 'dom-18',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/SG%20Open%201.mp3',
            mood: 'moderate'
        },
        {
            name: 'dom-19',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/sombre%20yams.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-20',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/spoopy%20vocal%205th.mp3',
            mood: 'unsafe'
        },
        {
            name: 'dom-21',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/storm%20songu.mp3',
            mood: 'moderate'
        },
    ];

    fieldFiles = [
        // Field Recordings
        // {
        //     name: 'jungle-1',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/jungle-1.mp3',
        // },
        // {
        //     name: 'jungle-2',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/jungle-2.mp3',
        // },
        // {
        //     name: 'jungle-3',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/jungle-3.mp3',
        // },
        // {
        //     name: 'jungle-4',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/jungle-4.mp3',
        // },
        // {
        //     name: 'jungle-5',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/jungle-5.mp3',
        // },
        {
            name: 'forest-surroundings',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/forest-surroundings.mp3',
            volume: 0.15
        },
        {
            name: 'bird-symphony',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/bird-symphony.mp3',
            volume: 0.15
        },
        // {
        //     name: '55349__eric5335__oklahoma-summernight-wildlife',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/55349__eric5335__oklahoma-summernight-wildlife.mp3',
        // },
        {
            name: '148422__rtb45__howler-monkeys-belize',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/148422__rtb45__howler-monkeys-belize.mp3',
            volume: 0.15
        },
        {
            name: '238878__danjocross__savannah-frogs-2',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/238878__danjocross__savannah-frogs-2.mp3',
            volume: 0.2
        },
        {
            name: '325321__rtb45__mount-moganshan-insect-chorus',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/325321__rtb45__mount-moganshan-insect-chorus.mp3',
            volume: 0.15
        },
        {
            name: '414401__samwd__mineiros-brasil-selva-31217-midnight-frog-chorus-long',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/414401__samwd__mineiros-brasil-selva-31217-midnight-frog-chorus-long.mp3',
            volume: 0.4
        },
        {
            name: '429048__calcuttan__dawn-chorus-from-himalayan-foothills',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/429048__calcuttan__dawn-chorus-from-himalayan-foothills.mp3',
            volume: 0.2
        },
        {
            name: '447819__courter__frogs-in-north-carolina-marshes',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/447819__courter__frogs-in-north-carolina-marshes.mp3',
            volume: 0.2
        },
        {
            name: '473569__rtb45__amazon-jungle-day',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/473569__rtb45__amazon-jungle-day.mp3',
            volume: 0.1
        },
        {
            name: '473570__rtb45__amazon-jungle-night',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/473570__rtb45__amazon-jungle-night.mp3',
            volume: 0.1
        },
        {
            name: '473572__rtb45__cloud-forest-frogs',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/473572__rtb45__cloud-forest-frogs.mp3',
            volume: 0.15
        },
        {
            name: '641475__rtb45__redwood-forest-after-rain',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/641475__rtb45__redwood-forest-after-rain.mp3',
            volume: 0.25
        },
        {
            name: '788360__audio_hoarder_garage__frogs-2-min',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/788360__audio_hoarder_garage__frogs-2-min.mp3',
            volume: 0.25
        },
        {
            name: '792679__thekingofgeeks360__frogs-spring-peepers-southern-chorus-frogs-and-insects-in-background',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/792679__thekingofgeeks360__frogs-spring-peepers-southern-chorus-frogs-and-insects-in-background.mp3',
            volume: 0.15
        },
        // {
        //     name: 'dawn-chorus',
        //     url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/dawn-chorus.mp3',
        // },
        {
            name: '807930__kvv_audio__anmlamph_frogs-croaking-01_kvv-audio_free',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/807930__kvv_audio__anmlamph_frogs-croaking-01_kvv-audio_free.mp3',
            volume: 0.15
        },
        {
            name: '798216__arablelands87__birds-bontebok-np-south-africa',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/798216__arablelands87__birds-bontebok-np-south-africa.mp3',
            volume: 0.25
        },
        {
            name: '798221__arablelands87__birds-dawn-chorus-tsitsikamma-south-africa',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/798221__arablelands87__birds-dawn-chorus-tsitsikamma-south-africa.mp3',
            volume: 0.25
        },
        {
            name: '735123__naturenotesuk__marsh-frogs-calling',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/735123__naturenotesuk__marsh-frogs-calling.mp3',
            volume: 0.2
        },
        {
            name: '641010__dibko__sestrze-pond-and-surroundings',
            url: 'https://gliese-assets.nyc3.cdn.digitaloceanspaces.com/641010__dibko__sestrze-pond-and-surroundings.mp3',
            volume: 0.3
        },
    ]

    playedMusicTracks = [];

    playedFieldRecordingTracks = [];

    currentBiome = 'EMPTY';
    currentZIndex = 0;
    isInitialised = false;
    isMusicMuted = false;
    audioElement;
    requiredMood;
    currentSong;

    loadedAudioCount = 0;

    cooldownSounds = []

    async loadAudio(phaser) {
        this.phaser = phaser;

        // this.playBackgroundMusic();
        this.playFieldRecording();
        this.loadSingleAudioFile();
    }

    loadSingleAudioFile() {
        const phaser = this.phaser;

        if (!this.audioFiles[this.loadedAudioCount]) {
            this.isInitialised = true;
            return;
        }

        const { name, url } = this.audioFiles[this.loadedAudioCount];

        phaser.load.audio(name, url)
            .once('complete', (key, type, data) => {
                this.loadedAudioCount++;
                this.loadSingleAudioFile();
            })
            .start()
    }

    loadSingleMusicFile(fileName) {
        // console.log('loadSingleMusicFile', fileName);
        if (this.isBackgroundMusicLoading) {
            return;
        }

        try {
            const phaser = this.phaser;

            if (!this.musicFiles.find(file => file.name === fileName)) {
                // console.log('CANNOT FIND TRACK: ', fileName);
                return;
            }

            const { name, url } = this.musicFiles.find(file => file.name === fileName);

            // console.log('loadSingleMusicFile', name, url);

            this.isBackgroundMusicLoading = true;

            phaser.load.audio(name, url)
                .once('complete', (key, type, data) => {
                    const backgroundMusic = this.phaser.sound.add(fileName, {
                        loop: false,
                        volume: 0.5
                    });

                    this.fadeIn(backgroundMusic, 1000);

                    if (this.currentSong) {
                        this.fadeOut(this.currentSong, 1000);
                    }

                    // We want at least 45 seconds of a song before changing
                    setTimeout(() => {
                        this.isBackgroundMusicLoading = false;
                    }, 45000)

                    this.currentSong = backgroundMusic;

                    backgroundMusic.on('complete', function() {
                        this.playedMusicTracks.push(fileName);

                        const FORTY_SECONDS = 1000 * 40;

                        // console.log('PLAY NEXT TRACK IN FORTY SECONDS 2!', new Date())

                        clearTimeout(this.musicQueueTimeout);

                        this.musicQueueTimeout = setTimeout(() => {
                            // console.log('PLAY NEXT SONG 2!', new Date())
                            this.playBackgroundMusic(); 
                        }, FORTY_SECONDS)
                    }.bind(this));
                })
                .start()
        } catch(e) {
            // console.log('OH NO TRACK COULDNT LOAD FOR SOME REASON!', fileName);
            this.loadSingleMusicFile();
        }
    }

    loadSingleFieldRecording(fileName) {
        // console.log('loadSingleFieldRecording', fileName);
        const phaser = this.phaser;

        if (!this.fieldFiles.find(file => file.name === fileName)) {
            // console.log('CANNOT FIND TRACK: ', fileName);
            return;
        }

        const { name, url, volume } = this.fieldFiles.find(file => file.name === fileName);

        // console.log('loadSingleFieldRecording', name, url);

        phaser.load.audio(name, url)
            .once('complete', (key, type, data) => {
                const backgroundMusic = this.phaser.sound.add(fileName, {
                    loop: false,
                    volume: (volume || 0.5) * 0.75
                });

                this.fadeIn(backgroundMusic, 1000);

                backgroundMusic.on('complete', function() {
                    this.playedFieldRecordingTracks.push(fileName);

                    const TWENTY_SECONDS = 1000 * 20;

                    setTimeout(() => {
                        this.playFieldRecording(); 
                    }, TWENTY_SECONDS)
                }.bind(this));
            })
            .start()
    }

    handleVisibilityChange(music) {
        if (document.hidden) {
            // Page is not in focus, do nothing to stop audio.
            // console.log("Tab is inactive");
        } else {
            // Page is back in focus, ensure the audio continues.
            if (!music.isPlaying) {
                music.resume(); // Resume the audio if it's paused
            }
        }
    }

    playBackgroundMusic() {
        // console.log('playBackgroundMusic')
        if (BALANCE.IS_AUDIO_DISABLED || this.isMusicMuted) {
            // console.log('BALANCE.IS_AUDIO_DISABLED')
            return;
        }

        if (this.isBackgroundMusicLoading) {
            console.log('nope this.isBackgroundMusicLoading')
            return;
        }

        const musicTracks = [
            'dry',
            'mountains',
            'tundra',
            'forests',
            'steppes',
            'evergreen',
            'savannah',
            'dom-1',
            'dom-2',
            'dom-3',
            'dom-4',
            'dom-5',
            'dom-6',
            'dom-7',
            'dom-8',
            'dom-9',
            'dom-10',
            'dom-11',
            'dom-12',
            'dom-13',
            'dom-14',
            'dom-15',
            'dom-16',
            'dom-17',
            'dom-18',
            'dom-19',
            'dom-20',
            'dom-21',
        ];

        const tracksToPlay = musicTracks.filter(track => (this.playedMusicTracks.indexOf(track) === -1))
            .filter(track => {
                const file = this.musicFiles.find(file => file.name === track)

                if (!file) {
                    // console.log('FILE NOT FOUND: ', track);
                    return;
                }

                return file.mood === this.requiredMood;
            })

        // console.log('tracksToPlay: ', tracksToPlay)

        if (tracksToPlay.length === 0) {
            this.playedMusicTracks = [];
            this.playBackgroundMusic();
            return;
        }

        const trackToPlay = getRandomItemFromArray(tracksToPlay);

        // console.log('trackToPlay: ', trackToPlay)

        try {
            const backgroundMusic = this.phaser.sound.add(trackToPlay, {
                loop: false,
                volume: 0.5
            });

            this.isBackgroundMusicLoading = true;

            this.fadeIn(backgroundMusic, 1000);

            if (this.currentSong) {
                this.fadeOut(this.currentSong, 1000);
            }

            this.currentSong = backgroundMusic;

            // We want at least 45 seconds of a song before changing
            setTimeout(() => {
                this.isBackgroundMusicLoading = false;
            }, 45000)

            backgroundMusic.on('complete', function() {
                this.playedMusicTracks.push(trackToPlay);

                const FORTY_SECONDS = 1000 * 40;
                // console.log('PLAY NEXT TRACK IN FORTY SECONDS!')

                clearTimeout(this.musicQueueTimeout);

                this.musicQueueTimeout = setTimeout(() => {
                    // console.log('PLAY NEXT TRACK!')
                    this.playBackgroundMusic(); 
                }, FORTY_SECONDS)
            }.bind(this));
        } catch(e) {
            // console.log('OH NO BETTER LOAD ONE UP!', trackToPlay, e)
            this.loadSingleMusicFile(trackToPlay);
        }
    }

    playFieldRecording() {
        if (BALANCE.IS_AUDIO_DISABLED) {
            return;
        }
        const fieldRecordingTracks = [
            '55349__eric5335__oklahoma-summernight-wildlife',
            'dawn-chorus',
            'forest-surroundings',
            'bird-symphony',
            '148422__rtb45__howler-monkeys-belize',
            '238878__danjocross__savannah-frogs-2',
            '325321__rtb45__mount-moganshan-insect-chorus',
            '414401__samwd__mineiros-brasil-selva-31217-midnight-frog-chorus-long',
            '429048__calcuttan__dawn-chorus-from-himalayan-foothills',
            '447819__courter__frogs-in-north-carolina-marshes',
            '473569__rtb45__amazon-jungle-day',
            '473570__rtb45__amazon-jungle-night',
            '473572__rtb45__cloud-forest-frogs',
            '641475__rtb45__redwood-forest-after-rain',
            '788360__audio_hoarder_garage__frogs-2-min',
            '792679__thekingofgeeks360__frogs-spring-peepers-southern-chorus-frogs-and-insects-in-background',
            '807930__kvv_audio__anmlamph_frogs-croaking-01_kvv-audio_free',
            '798216__arablelands87__birds-bontebok-np-south-africa',
            '798221__arablelands87__birds-dawn-chorus-tsitsikamma-south-africa',
            '735123__naturenotesuk__marsh-frogs-calling',
            // '641010__dibko__sestrze-pond-and-surroundings' -> I don't like
        ];

        const tracksToPlay = fieldRecordingTracks.filter(track => (this.playedFieldRecordingTracks.indexOf(track) === -1));

        if (tracksToPlay.length === 0) {
            this.playedFieldRecordingTracks = [];
            this.playFieldRecording();
            return;
        }

        const trackToPlay = getRandomItemFromArray(tracksToPlay);

        const { name, url, volume } = this.fieldFiles.find(file => file.name === trackToPlay);

        try {
            const fieldRecording = this.phaser.sound.add(trackToPlay, {
                loop: false,
                volume: (volume || 0.5) * 0.75
            });

            this.fadeIn(fieldRecording, 1000);

            fieldRecording.on('complete', function() {
                this.playedFieldRecordingTracks.push(trackToPlay);
                this.playFieldRecording(); 
            }.bind(this));
        } catch(e) {
            this.loadSingleFieldRecording(trackToPlay);
        }
    }

    // TODO: Fade In function
    fadeIn(track, duration) {
        track.play();
    }

    fadeOut(track, duration) {
        if (!track) {
            return;
        }
        this.phaser.tweens.add({
            targets: track,
            volume: 0,
            duration,
            onComplete: () => {
                track.stop();
            }
        });
    }

    setRequiredMood(requiredMood) {
        if (requiredMood !== this.requiredMood) {
            this.requiredMood = requiredMood

            if (this.isBackgroundMusicLoading) {
                // we should in fact just wait for this to be false and THEN do some stuff...
                return;
            }

            this.fadeOut(this.currentSong, 1000);

            // console.log('CLEARING TIMEOUT', new Date());
            clearTimeout(this.musicQueueTimeout);

            this.musicQueueTimeout = setTimeout(() => {
                // console.log('PLAYING BACKGROUND MUSIC!');
                this.playBackgroundMusic();
            }, 4000);
        }
    }

    playSound(soundName) {
        if (BALANCE.IS_AUDIO_DISABLED) {
            return;
        }

        try {
            const soundNameMatches = this.audioFiles.filter(file => (file.name.indexOf(soundName) > -1));
            const randomMatch = getRandomItemFromArray(soundNameMatches);
    
            soundName = randomMatch.name;
    
            if (this.cooldownSounds.indexOf(soundName) === -1) {
                this.cooldownSounds.push(soundName);
    
                const soundDetails = this.audioFiles.find(file => (file.name === soundName))
    
                const detune = Phaser.Math.Between(-100, 100);
                const rate = Phaser.Math.FloatBetween(0.9, 1.1);
                soundDetails.volume = soundDetails.volume || 0.5;
                const volume = Phaser.Math.FloatBetween(soundDetails.volume - 0.1, soundDetails.volume + 0.1);
    
                const sound = this.phaser.sound.add(soundName, {
                    detune,
                    rate,
                    volume,
                });
                sound.play();
    
                setTimeout(() => {
                    this.cooldownSounds = this.cooldownSounds.filter(name => name !== soundName)
                }, soundDetails.cooldown || 0)
            }
        } catch(e) {
            // console.error('Sound failed: ', e)
        }

    }

    muteMusic() {
        this.isMusicMuted = true;
        this.isBackgroundMusicLoading = false;
        this.fadeOut(this.currentSong, 0);
    }

    unmuteMusic() {
        this.isMusicMuted = false;
        this.playBackgroundMusic()
    }

    setBiome(biome) {
        this.currentBiome = biome;
    }

    setZIndex(zIndex) {
        this.currentZIndex = zIndex;
    }
}

export default AudioService;

function getRandomItemFromArray(items) {
    return items[Math.floor(Math.random() * items.length)];
}